import moment from 'moment';

import { isBeforeDay } from './isBeforeDay';

export const isInclusivelyAfterDay = (a?: moment.Moment, b?: moment.Moment): boolean => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return !isBeforeDay(a, b);
};
